<div class="grid grid-gutter-4">
  <div class="grid-item" *ngFor="let key of keyboard">
    <button
      class="button button-xs"
      [ngClass]="key.symbol === activeKey ? 'button-primary' : 'button-subtle button-bordered'"
      [disabled]="key.disabled"
      [nzTooltipTitle]="key.disabled ? tooltipContent : undefined"
      nz-tooltip
      (click)="active(key)"
      >
        {{ key.symbol }}
      </button>
  </div>
</div>
<ng-template #tooltipContent>
  <div class="grid grid-gutter-8 grid-nowrap align-items-center">
    <div class="grid-item">
      <span class="icon icon-16 icon-alert-circle grey-700"></span>
    </div>
    <div class="grid-item typography typography-body">
      Здесь пока ничего нет
    </div>
  </div>
</ng-template>
